import { MessageType } from "@/types/enums/message";

export const getMessageBadgeVariant = (messageType: MessageType) => {
  switch (messageType) {
    case MessageType.UPDATE:
      return "warning";
    case MessageType.EXPIRED:
    case MessageType.OVERRIDE:
    case MessageType.CANCELLED:
      return "error";
    default:
      return "default";
  }
};
